import {filterVoucherCampaign} from '../../../backend-services/Campaigns/discountsHelper';
import {useDiscounts} from '../../../backend-services/Campaigns/hooks/useDiscounts';
import {useShowCampaignPhonePopup} from '../../../backend-services/Campaigns/hooks/useShowCampaignPhonePopup';
import {useIsAppWelcomeCouponBannerEnabled} from '../../Coupons/useIsAppWelcomeCouponBannerEnabled';
import {useIsCouponsEnabled} from '../../Coupons/useIsCouponsEnabled';
import {useIsWebCouponsEnabled} from '../../Coupons/useIsWebCouponsEnabled';

export const useIsGenericWebCouponBannerEnabled = () => {
  // TODO: remove this during the cleanup phase https://aboutyou.atlassian.net/browse/ASFE-10356
  const isWebCouponsActive = useIsWebCouponsEnabled();
  const isCouponsActive = useIsCouponsEnabled();
  const isAppWelcomeCouponBannerEnabled = useIsAppWelcomeCouponBannerEnabled();

  const showCampaignPhonePopup = useShowCampaignPhonePopup();
  const {data} = useDiscounts();
  const discountDataWithoutVoucherCampaign = filterVoucherCampaign(
    data?.discounts || [],
  );

  // coupons are the lowest in the campaign framework:
  // if a user has an active PD, PX Major, PX Minor, Crazy bet, App flash Sale is running, Coupon promotions are not shown
  return (
    isAppWelcomeCouponBannerEnabled &&
    (isWebCouponsActive || isCouponsActive) &&
    !showCampaignPhonePopup &&
    discountDataWithoutVoucherCampaign?.length === 0
  );
};
